/**
 * /projects/new — manual project request / creation.
 *
 * Thin route wrapper around the shared <FormIntakePanel> (page variant), which
 * owns the form, the manual document uploader, draft autosave, and the create
 * call. The same panel renders embedded in the calendar's New-project modal.
 *
 * Wireframe: docs/wireframes/01-requester-intake.html
 */
import { useNavigate } from 'react-router-dom';
import { FormIntakePanel } from '@/components/intake/FormIntakePanel';

export function ProjectNew() {
  const navigate = useNavigate();
  return (
    <div className="p-6 max-w-5xl mx-auto space-y-4">
      <FormIntakePanel variant="page" onCreated={(p) => navigate(`/projects/${p.id}`)} />
    </div>
  );
}
